import React from 'react';
import {AlertTriangleIcon} from '../Icons';

interface AccountCardProps {
    title: string;
    description: string;
    /** Rendered above the body. Null / empty hides the banner entirely. */
    error?: string | null;
    children: React.ReactNode;
}

/** One settings section on the account page. */
const AccountCard: React.FC<AccountCardProps> = ({title, description, error, children}) => (
  <section className="rounded-xl border border-gray-800 bg-gray-900 p-6">
    <h2 className="text-sm font-semibold text-gray-100">{title}</h2>
    <p className="mt-0.5 text-xs text-gray-500">{description}</p>

    {error && (
      <div className="mt-4 flex items-start gap-2 rounded-lg border border-red-500/30
       bg-red-500/[0.06] px-3 py-2.5 text-sm text-red-200">
        <AlertTriangleIcon className="mt-0.5 w-4 h-4 shrink-0" />
        <span>{error}</span>
      </div>
    )}

    {children}
  </section>
);

export default AccountCard;
